import React from 'react';
import { Grid2, Stack, Typography } from '@mui/material';
import { ReactComponent as NoArticles } from 'assets/images/EmptyState/NoArticles.svg';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { RESOURCE_LAYOUT_GRID_COLUMNS } from 'themes/constants';

export const ResourceNoArticlesState = () => {
  const { translation } = useTranslationContext();

  return (
    <Grid2 size={RESOURCE_LAYOUT_GRID_COLUMNS}>
      <Stack alignItems="center" spacing={2} sx={{ py: 6 }}>
        <NoArticles role="img" aria-label="No articles" width={240} height={250} />
        <Typography
          variant="headline"
          textAlign="center"
          fontWeight={500}
          sx={{ color: (theme) => theme.palette.primary.main }}
        >
          {translation('library_empty_state_title')}
        </Typography>
        <Typography
          variant="callout"
          textAlign="center"
          sx={{ color: (theme) => theme.palette.grey[800] }}
        >
          {translation('library_empty_state_message')}
        </Typography>
      </Stack>
    </Grid2>
  );
};

ResourceNoArticlesState.displayName = 'ResourceNoArticlesState';
